<template>
  <v-app>
    <v-overlay z-index="999" :value="isLoading" color="white">
      <div class="flex-column align-center">
        <v-progress-circular indeterminate size="60" width="3" color="#8DB9CA"/>
      </div>
    </v-overlay>
    <div v-if="!successMessage">
      <ValidationObserver ref="validator">
          <div class="text-40 font-BebasNeueProBold">{{ $t('CONTACT_FORM.DATA.TITLE') }}</div>
          <div class="grid grid-cols-12 gap-x-4">
            <div class="col-span-12 lg:col-span-6">
              <ValidationProvider v-slot="{ errors }" name="firstName" rules="required">
                <v-text-field
                    v-model="contactForm.firstName"
                    :label="`${$t('CONTACT_FORM.FIRST_NAME')}*`"
                    :error="errors.length > 0"
                    required
                ></v-text-field>
              </ValidationProvider>
            </div>
            <div class="col-span-12 lg:col-span-6">
              <ValidationProvider v-slot="{ errors }" name="lastName" rules="required">
                <v-text-field
                    v-model="contactForm.lastName"
                    :label="`${$t('CONTACT_FORM.LAST_NAME')}*`"
                    :error="errors.length > 0"
                    required
                ></v-text-field>
              </ValidationProvider>
            </div>
          </div>
          <v-text-field
              v-model="contactForm.company"
              :label="`${$t('CONTACT_FORM.COMPANY')}`"
          ></v-text-field>
          <ValidationProvider v-slot="{ errors }" name="email" rules="email|required">
            <v-text-field
                v-model="contactForm.email"
                :label="`${$t('CONTACT_FORM.E_MAIL')}*`"
                :error="errors.length > 0"
                required
            ></v-text-field>
          </ValidationProvider>
          <div class="grid grid-cols-12 gap-x-4">
            <div class="col-span-12 lg:col-span-6">
              <v-text-field
                  v-model="contactForm.phone"
                  :label="$t('CONTACT_FORM.PHONE')"
              ></v-text-field>
            </div>
            <div class="col-span-12 lg:col-span-6">
              <ValidationProvider v-slot="{ errors }" name="mobile" rules="required">
                <v-text-field
                    v-model="contactForm.mobile"
                    :label="`${$t('CONTACT_FORM.MOBILE')}*`"
                    :error="errors.length > 0"
                    required
                ></v-text-field>
              </ValidationProvider>
            </div>
          </div>
          <div class="text-40 font-BebasNeueProBold mt-4 lg:mt-8">{{ $t('CONTACT_FORM.MESSAGE.TITLE') }}</div>
          <ValidationProvider v-slot="{ errors }" name="message" rules="required">
            <v-textarea
                v-model="contactForm.message"
                :label="`${$t('CONTACT_FORM.MESSAGE')}*`"
                :error="errors.length > 0"
                required
            ></v-textarea>
          </ValidationProvider>
          <div class="mt-4 lg:mt-8">*{{ $t('CONTACT_FORM.REQUIRED_FIELDS') }}</div>
          <div v-if="showErrorMessage" class="flex-grow text-center py-4 error--text">
            {{ $t('CONTACT_FORM.ERROR') }}
          </div>
          <div class="flex justify-end mt-4">
            <button class="button" @click="send()">{{ $t('CONTACT_FORM.BUTTON_SEND') }}</button>
          </div>
      </ValidationObserver>
    </div>
    <div v-else class="success--text text-center mb-10">{{ $t(successMessage) }}</div>
  </v-app>
</template>

<script>
import {VApp, VTextField, VTextArea} from 'vuetify/lib';
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import contactFormService from "../services/contactFormService";

const emptyContactForm = {
  firstName: null,
  lastName: null,
  company: null,
  email: null,
  phone: null,
  mobile: null,
  message: null,
};

export default {
  name: 'ContactForm',
  components: {
    ValidationProvider,
    ValidationObserver,
    VApp,
    VTextField,
    VTextArea
  },
  data: () => ({
    contactForm: [{...emptyContactForm}],
    showErrorMessage: false,
    successMessage: null,
    isLoading: false
  }),
  methods: {
    send() {
      this.$refs.validator.validate().then(valid => {
        if (valid) {
          this.showErrorMessage = false;
          this.successMessage = null;
          this.isLoading = true;
          contactFormService
              .sendContactForm({
                firstName: this.contactForm.firstName,
                lastName: this.contactForm.lastName,
                company: this.contactForm.company || null,
                email: this.contactForm.email,
                phone: this.contactForm.phone || null,
                mobile: this.contactForm.mobile,
                message: this.contactForm.message,
                [window.csrfTokenName]: window.csrfTokenValue
              })
              .then(() => {
                this.successMessage = 'CONTACT_FORM.SUCCESS';
                this.isLoading = false;
              })
              .catch(_ => {
                this.showErrorMessage = true;
                this.isLoading = false;
              });
        }
      });
    }
  }
};
</script>
